(function() {

    // Add the directive to the module
    angular.module("Sinewav3.Client.Shell")
        .directive(
            'adminToolbar',
            [
                'CHROME',
                AdminToolbarFactory
            ]
        );

    // Factory Method
    function AdminToolbarFactory(CHROME)
    {
        // Construct and return the instance
        return {
            restrict: 'E',
            controller: 'ToolbarController',
            controllerAs: 'toolbarCtrl',
            templateUrl: CHROME.PREFIX + CHROME.TOOLBAR.ADMIN + CHROME.POSTFIX
    };

    }
})();



